export const REMINDER_PRESET_NAMES = ['relaxed', 'standard', 'tight'];
/** Distance lead for each preset, per unit system. */
const LEAD_DISTANCE = {
    imperial: { relaxed: 1000, standard: 500, tight: 250 },
    metric: { relaxed: 1600, standard: 800, tight: 400 },
};
/** Time-based shape of each preset — identical across unit systems. */
const TIME_SHAPE = {
    relaxed: { leadDays: 45, repeatWeeks: 4, followUpDays: 60 },
    standard: { leadDays: 30, repeatWeeks: 2, followUpDays: 30 },
    tight: { leadDays: 14, repeatWeeks: 1, followUpDays: 14 },
};
function buildPreset(unit, name) {
    const shape = TIME_SHAPE[name];
    return Object.freeze({
        leadDays: shape.leadDays,
        leadMiles: LEAD_DISTANCE[unit][name],
        repeatWeeks: shape.repeatWeeks,
        followUpEnabled: true,
        followUpDays: shape.followUpDays,
    });
}
function buildPresetsForUnit(unit) {
    return Object.freeze({
        relaxed: buildPreset(unit, 'relaxed'),
        standard: buildPreset(unit, 'standard'),
        tight: buildPreset(unit, 'tight'),
    });
}
const PRESETS_BY_UNIT = {
    imperial: buildPresetsForUnit('imperial'),
    metric: buildPresetsForUnit('metric'),
};
/** The three maintenance-reminder presets expressed in the given unit system. */
export function reminderPresets(unit) {
    return PRESETS_BY_UNIT[unit];
}
//# sourceMappingURL=reminder-presets.js.map